import axios from "axios";

function apiGet(context, url, mutation) {
  const auth = context.getters.get_credential;
  return axios.get(url, { auth }).then((res) => {
    if (mutation) context.commit(mutation, res.data);
    return res.data;
  });
}

export default {
  state: {
    rapporto_verde: [],
    rapporto_verde_contabile: [],
    rapporto_verde_confronto_contabile: [],
    rapporto_verde_confronto: [],
    rapporto_verde_confronto_fine_anno: [],
    rapporto_verde_tabella: [],
    rapporto_verde_tabella_confronto: [],
    prodotti_venduti: [],
    prodotti_venduti_confronto: [],
    ordini_trend: [],
    visite: [],
    analisi_ordine: [],
    analisi_prodotti: [],
    accessi: [],
    qr_scan: [],
    analisi_clienti: [],
    analisi_clienti_confronto: [],
  },
  getters: {
    get_rapporto_verde: (state) => {
      return state.rapporto_verde;
    },
    get_rapporto_verde_contabile: (state) => {
      return state.rapporto_verde_contabile;
    },
    get_rapporto_verde_confronto: (state) => {
      return state.rapporto_verde_confronto;
    },
    get_rapporto_verde_confronto_contabile: (state) => {
      return state.rapporto_verde_confronto_contabile;
    },
    get_rapporto_verde_confronto_fine_anno: (state) => {
      return state.rapporto_verde_confronto_fine_anno;
    },
    get_rapporto_verde_tabella: (state) => {
      return state.rapporto_verde_tabella;
    },
    get_rapporto_verde_tabella_confronto: (state) => {
      return state.rapporto_verde_tabella_confronto;
    },
    get_prodotti_venduti: (state) => {
      return state.prodotti_venduti;
    },
    get_prodotti_venduti_confronto: (state) => {
      return state.prodotti_venduti_confronto;
    },
    get_ordini_trend: (state) => {
      return state.ordini_trend;
    },
    get_visite: (state) => {
      return state.visite;
    },
    get_analisi_ordine_cliente: (state) => {
      return state.analisi_ordine;
    },
    get_analisi_prodotti: (state) => {
      return state.analisi_prodotti;
    },
    get_accessi_cliente: (state) => {
      return state.accessi;
    },
    get_qr_scan: (state) => {
      return state.qr_scan;
    },
    get_analisi_clienti: (state) => {
      return state.analisi_clienti;
    },
    get_analisi_clienti_confronto: (state) => {
      return state.analisi_clienti_confronto;
    },
  },
  mutations: {
    set_rapporto_verde(state, rapporto) {
      state.rapporto_verde = rapporto;
    },
    set_rapporto_verde_contabile(state, rapporto) {
      state.rapporto_verde_contabile = rapporto;
    },
    set_rapporto_verde_confronto(state, rapporto) {
      state.rapporto_verde_confronto = rapporto;
    },
    set_rapporto_verde_confronto_contabile(state, rapporto) {
      state.rapporto_verde_confronto_contabile = rapporto;
    },
    set_rapporto_verde_confronto_fine_anno(state, rapporto) {
      state.rapporto_verde_confronto_fine_anno = rapporto;
    },
    set_rapporto_verde_confronto_contabile_fine_anno(state, rapporto) {
      state.rapporto_verde_confronto_contabile_fine_anno = rapporto;
    },
    set_rapporto_verde_tabella(state, rapporto) {
      state.rapporto_verde_tabella = rapporto;
    },
    set_rapporto_verde_tabella_confronto(state, rapporto) {
      state.rapporto_verde_tabella_confronto = rapporto;
    },
    set_prodotti_venduti(state, prodotti) {
      state.prodotti_venduti = prodotti;
    },
    set_prodotti_venduti_confronto(state, prodotti) {
      state.prodotti_venduti_confronto = prodotti;
    },
    set_ordini_trend(state, ordini) {
      state.ordini_trend = ordini;
    },
    set_visite(state, visite) {
      state.visite = visite;
    },
    set_analisi_ordine(state, analisi) {
      state.analisi_ordine = analisi;
    },
    set_analisi_prodotti(state, analisi) {
      state.analisi_prodotti = analisi;
    },
    set_accessi_clienti(state, accessi) {
      state.accessi = accessi;
    },
    set_qr_scan(state, qr_scan) {
      state.qr_scan = qr_scan;
    },
    set_analisi_clienti(state, analisi) {
      state.analisi_clienti = analisi;
    },
    set_analisi_clienti_confronto(state, analisi) {
      state.analisi_clienti_confronto = analisi;
    },
  },
  actions: {
    fetch_rapporto_verde(context, payload) {
      const url = `${process.env.VUE_APP_API_ROOT}/admin/statistiche/rapporto_verde/${payload.ts_inizio}/${payload.ts_fine}${payload.risoluzione ? '/' + payload.risoluzione : ''}`;
      return apiGet(context, url, "set_rapporto_verde");
    },
    fetch_rapporto_verde_contabile(context, payload) {
      return new Promise((resolve, reject) => {
        let url =
          process.env.VUE_APP_API_ROOT +
          "/admin/statistiche/contabili/rapporto_verde/" +
          payload.ts_inizio +
          "/" +
          payload.ts_fine +
          (payload.risoluzione ? "/" + payload.risoluzione : "");
        let auth = context.getters.get_credential;
        axios
          .get(url, { auth: auth })
          .then((res) => {
            context.commit("set_rapporto_verde", res.data);
            resolve("ok");
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetch_rapporto_verde_confronto(context, payload) {
      const url = `${process.env.VUE_APP_API_ROOT}/admin/statistiche/rapporto_verde/${payload.ts_inizio}/${payload.ts_fine}${payload.risoluzione ? '/' + payload.risoluzione : ''}`;
      return apiGet(context, url, "set_rapporto_verde_confronto");
    },
    fetch_rapporto_verde_confronto_contabile(context, payload) {
      const url = `${process.env.VUE_APP_API_ROOT}/admin/statistiche/contabili/rapporto_verde/${payload.ts_inizio}/${payload.ts_fine}${payload.risoluzione ? '/' + payload.risoluzione : ''}`;
      return apiGet(context, url, "set_rapporto_verde_confronto");
    },
    fetch_rapporto_verde_confronto_fine_anno(context, payload) {
      const url = `${process.env.VUE_APP_API_ROOT}/admin/statistiche/rapporto_verde/${payload.ts_inizio}/${payload.ts_fine}${payload.risoluzione ? '/' + payload.risoluzione : ''}`;
      return apiGet(context, url, "set_rapporto_verde_confronto_fine_anno");
    },
    fetch_rapporto_verde_confronto_fine_anno_contabili(context, payload) {
      const url = `${process.env.VUE_APP_API_ROOT}/admin/statistiche/contabili/rapporto_verde/${payload.ts_inizio}/${payload.ts_fine}${payload.risoluzione ? '/' + payload.risoluzione : ''}`;
      return apiGet(context, url, "set_rapporto_verde_confronto_fine_anno");
    },
    fetch_rapporto_verde_tabella(context, payload) {
      const url = `${process.env.VUE_APP_API_ROOT}/admin/statistiche/rapporto_verde/${payload.ts_inizio}/${payload.ts_fine}${payload.risoluzione ? '/' + payload.risoluzione : ''}`;
      return apiGet(context, url, "set_rapporto_verde_tabella");
    },
    fetch_rapporto_verde_tabella_contabile(context, payload) {
      const url = `${process.env.VUE_APP_API_ROOT}/admin/statistiche/contabili/rapporto_verde/${payload.ts_inizio}/${payload.ts_fine}${payload.risoluzione ? '/' + payload.risoluzione : ''}`;
      return apiGet(context, url, "set_rapporto_verde_tabella");
    },
    fetch_rapporto_verde_tabella_confronto(context, payload) {
      const url = `${process.env.VUE_APP_API_ROOT}/admin/statistiche/rapporto_verde/${payload.ts_inizio}/${payload.ts_fine}${payload.risoluzione ? '/' + payload.risoluzione : ''}`;
      return apiGet(context, url, "set_rapporto_verde_tabella_confronto");
    },
    fetch_rapporto_verde_tabella_confronto_contabile(context, payload) {
      const url = `${process.env.VUE_APP_API_ROOT}/admin/statistiche/contabili/rapporto_verde/${payload.ts_inizio}/${payload.ts_fine}${payload.risoluzione ? '/' + payload.risoluzione : ''}`;
      return apiGet(context, url, "set_rapporto_verde_tabella_confronto");
    },
    fetch_prodotti_venduti(context, payload) {
      const url = `${process.env.VUE_APP_API_ROOT}/admin/statistiche/prodotti_venduti/${payload.ts_inizio}/${payload.ts_fine}`;
      return apiGet(context, url, "set_prodotti_venduti");
    },
    fetch_prodotti_venduti_confronto(context, payload) {
      const url = `${process.env.VUE_APP_API_ROOT}/admin/statistiche/prodotti_venduti/${payload.ts_inizio}/${payload.ts_fine}`;
      return apiGet(context, url, "set_prodotti_venduti_confronto");
    },
    fetch_prodotto_venduto(context, payload) {
      const url = `${process.env.VUE_APP_API_ROOT}/admin/statistiche/prodotto_venduto/${payload.id_prodotto}/${payload.ts_inizio}/${payload.ts_fine}`;
      return apiGet(context, url, null);
    },
    fetch_prodotto_clienti(context, payload) {
      const url = `${process.env.VUE_APP_API_ROOT}/admin/statistiche/prodotto_clienti/${payload.id_prodotto}/${payload.ts_inizio}/${payload.ts_fine}`;
      return apiGet(context, url, null);
    },
    fetch_prodotto_colori(context, payload) {
      const url = `${process.env.VUE_APP_API_ROOT}/admin/statistiche/prodotto_colori/${payload.id_prodotto}/${payload.ts_inizio}/${payload.ts_fine}`;
      return apiGet(context, url, null);
    },
    fetch_ordini_trend(context, payload) {
      const url = `${process.env.VUE_APP_API_ROOT}/admin/statistiche/trend_ordini/${payload.ts_inizio}/${payload.ts_fine}`;
      return apiGet(context, url, "set_ordini_trend");
    },
    fetch_visite(context, payload) {
      const url = `${process.env.VUE_APP_API_ROOT}/admin/statistiche/visite/${payload.ts_inizio}/${payload.ts_fine}`;
      return apiGet(context, url, "set_visite");
    },
    fetch_analisi_ordine(context, payload) {
      const url = `${process.env.VUE_APP_API_ROOT}/admin/statistiche/rapporto_verde/${payload.ts_inizio}/${payload.ts_fine}`;
      return apiGet(context, url, "set_analisi_ordine");
    },
    fetch_analisi_clienti(context, payload) {
      return new Promise((resolve, reject) => {
        let url;
        if (payload.usa_contabili) {
          url =
            process.env.VUE_APP_API_ROOT +
            "/admin/statistiche/contabili/rapporto_verde_clienti/" +
            payload.ts_inizio +
            "/" +
            payload.ts_fine;
        } else {
          url =
            process.env.VUE_APP_API_ROOT +
            "/admin/statistiche/rapporto_verde_clienti/" +
            payload.ts_inizio +
            "/" +
            payload.ts_fine;
        }
        let auth = context.getters.get_credential;
        axios
          .get(url, { auth: auth })
          .then((res) => {
            if (payload.confronto) {
              context.commit("set_analisi_clienti_confronto", res.data);
            } else {
              context.commit("set_analisi_clienti", res.data);
            }
            resolve("ok");
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    fetch_analisi_prodotti(context, payload) {
      const url = `${process.env.VUE_APP_API_ROOT}/admin/statistiche/prodotti_venduti/${payload.ts_inizio}/${payload.ts_fine}`;
      return apiGet(context, url, "set_analisi_prodotti");
    },
    fetch_analisi_cliente_dettaglio(context, payload) {
      const url = `${process.env.VUE_APP_API_ROOT}/admin/statistiche/analisi_cliente/${payload.iva}/${payload.ts_inizio}/${payload.ts_fine}`;
      return apiGet(context, url, null);
    },
    fetch_accessi_clienti(context, payload) {
      const url = `${process.env.VUE_APP_API_ROOT}/admin/logs/accessi/${payload.ts_inizio}/${payload.ts_fine}`;
      return apiGet(context, url, "set_accessi_clienti");
    },
    fetch_qr_scan(context, payload) {
      const url = `${process.env.VUE_APP_API_ROOT}/admin/statistiche/qr_scan_stat/ts_inizio/${payload.ts_inizio}`;
      return apiGet(context, url, "set_qr_scan");
    },
    delete_qr_scan(context, payload) {
      return new Promise((resolve, reject) => {
        let url =
          process.env.VUE_APP_API_ROOT +
          "/admin/statistiche/qr_scan/ts_inizio/" +
          payload.ts_inizio;
        let auth = context.getters.get_credential;
        axios
          .delete(url, { auth: auth })
          .then(() => {
            resolve("ok");
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
